import { xor } from 'lodash';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { selectImpactedEntities } from '../../modules/changeImpacts.js';
import EmployeesCombobox from '../employees-form-field/EmployeesCombobox.jsx';
import styles from './EmployeesFilter.module.css';

const mapStateToProps = (state, ownProps) => ({
  impactedEmployees: selectImpactedEntities(ownProps.id)(
    state
  ).impactedEmployees.filter((i) => !i.archived),
});

EmployeesFilter.defaultProps = {
  selectedEmployeesIds: [],
};

function EmployeesFilter({
  impactedEmployees,
  selectedEmployeesIds,
  navigateAction,
}) {
  const handleSelect = useCallback(
    ({ id }) => {
      return navigateAction({
        impactedEmployeesIds: id ? xor(selectedEmployeesIds, [id]) : [],
      });
    },
    [selectedEmployeesIds]
  );

  return (
    <div className={`flex-col report-filter ${styles.reportFilter}`}>
      <div className="text-muted filter-label">People Impacted</div>
      <EmployeesCombobox
        selectedEmployeeIds={selectedEmployeesIds}
        employees={impactedEmployees}
        handleSelect={handleSelect}
      />
    </div>
  );
}

export default connect(mapStateToProps)(EmployeesFilter);
